import _taggedTemplateLiteral from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from "styled-components";
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: 10px;\n"])));